import type { ComponentChildren } from 'preact';

export type Props = {
	subtitle: ComponentChildren;
};

export function ModalSubtitle({ subtitle }: Props) {
	return <p class={'md:mr-16 mb-4 text-dark-blue-50'}>{subtitle}</p>;
}
